'use strict';

(function () {
  'use strict';

  angular.module('msProfile').component('msDateInput', {
    require: {
      ngModel: '^ngModel'
    },
    bindings: {
      isSubjectToGdpr: '<',
      collectDayOfBirth: '<'
    },
    templateUrl: 'profile/templates/dateInput.html',
    controller: [function () {
      var vm = this;
      vm.$onInit = init;
      vm.update = update;
      vm.date = [];

      function init() {
        vm.currentYear = moment().year();
        vm.months = moment.months();
        vm.days = _.range(1, 31 + 1);
        vm.ngModel.$render = render;
      }

      function render() {
        vm.date = angular.copy(vm.ngModel.$modelValue || []);
        // the collectDayOfBirth came from the YAML env file and was needed for member anonymization
        if (!vm.collectDayOfBirth) {
          vm.date[2] = 1;
        }
        update();
      }

      function update() {
        var year = vm.date[0];
        var month = vm.date[1];
        var day = vm.date[2];
        if (year && month) {
          // Moment uses 0-based months, our model uses 1-based
          var daysInMonth = moment({ year: year, month: month - 1 }).daysInMonth();
          vm.days = _.range(1, daysInMonth + 1);
          // If the day is out of range, trim down to the last day in the month
          if (day > daysInMonth) {
            vm.date[2] = daysInMonth;
          }
        }
        if (year && month && day) {
          vm.ngModel.$setViewValue(angular.copy(vm.date));
          vm.ngModel.$setValidity('required', true);
        } else {
          vm.ngModel.$setValidity('required', false);
        }
      }
    }]
  });
})();